export default "__VITE_ASSET__22f06528__"